import React from 'react';
import SideBar from '../../../shared/templates/CategoryTemplate/category-sidebar';

function BlogsSideBar(props) {
  return (<SideBar {...props} 
    section="blogs"
    searchTitle="Search Blogs"
    createNewTitle="New Blog"
    filterList={[
      { name:'keywords', value: 'Enter Keywords' }, 
    ]}
  />);
}

export default BlogsSideBar;